import { Table } from "react-bootstrap";
import { ComisionesPagoServicios } from "../../domain/models/ComisionesPagoServicios";
import { CurrencyUtils } from "../../common/CurrencyUtils";
import '../../styles/tableReportComsPagoServicio.css';

interface ReporteComsTablaProps {
  listMovs: Array<any>;
}

export const ReporteComsTabla: React.FC<ReporteComsTablaProps> = ({ listMovs }) => {
  return (
    <>
      <div className="mt-5">
        <h3>
          Reporte Comisiones Pago de Servicio
        </h3>
      </div>
      <div className="table-responsive resp TableComisionePagoServ">
        <Table hover responsive className="table resp">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Tipo Modelo</th>
              <th>Carrier</th>
              <th>Destino</th>
              <th>Medio</th>
              <th>Monto</th>
              <th>Num Op Prepago</th>
              <th>Mov Clave</th>
              <th>Saldo Inicial</th>
              <th>Comisión Compra</th>
              <th>Cobro Por Servicio</th>
              <th>Ajuste Por Comisión Compra</th>
              <th>Saldo Final</th>
            </tr>
          </thead>
          <tbody>
            {listMovs && listMovs.map((item: ComisionesPagoServicios) => <tr className="TableComisionePagoServ" key={item.mov_clave}>
              <td style={{ whiteSpace: 'nowrap' }}>{item.fecha}</td>
              <td>{item.hora}</td>
              <td>{item.tipo_modelo}</td>
              <td>{item.carrier}</td>
              <td>{item.destino}</td>
              <td>{item.medio}</td>
              <td>{CurrencyUtils.moneyFormat(item.monto)}</td>
              <td>{item.num_op_prepago}</td>
              <td>{item.mov_clave}</td>
              <td className="saldo-inicial">{CurrencyUtils.moneyFormat(item.saldo_ini_pdv)}</td>
              <td>{item.comision_compra_pdv}&#37;</td>
              <td>{CurrencyUtils.moneyFormat(item.comision_servicio_pdv)}</td>
              <td className={`ajuste-compra ${item.ajuste_compra_pdv < 0 ? 'negative' : ''}`}>{CurrencyUtils.moneyFormat(item.ajuste_compra_pdv)}</td>
              <td className="saldo-final">{CurrencyUtils.moneyFormat(item.saldo_fin_pdv)}</td>
            </tr>)}
          </tbody>
        </Table>
      </div>
    </>
  )
}